import React, { useEffect, useState } from 'react';
import cn from "classnames";
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/utils/Loader";
import { isEmpty } from "lodash";
import ReactTooltip from "react-tooltip";
import { TableHeader } from "./TableHeader";
import { ItemRow } from "./ItemRow";
import { styles } from "../../../containers/goods/styles";
import Select from 'react-select';
import {
    inventoryFormsLoadingSelector,
    pointLoadingSelector,
} from "../../../selectors/forms";
import { fetchInventoryForms, recalculationInventories, setInventoryFilters, setPagingInventory } from '../../../action';
import ReactPaginate from 'react-paginate';
import { roleId } from '../../../constants/app';
import swal from 'sweetalert';

const InventoryList = ({ points, onRefresh }) => {
    const loading = useSelector(inventoryFormsLoadingSelector);
    const pointsLoading = useSelector(pointLoadingSelector);
    const UImobile = useSelector(state => state.UImobile);
    const paging = useSelector(state => state.inventoryForms.paging);
    const count = useSelector(state => state.inventoryForms.count);
    const items = useSelector(state => state.inventoryForms.items);
    const filters = useSelector(state => state.inventoryForms.filters);
    const user = useSelector(state => state.user.info);

    const [currentPage, setCurrentPage] = useState(0);
    const [cities, setCities] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

    const dispatch = useDispatch();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setCities(points.map((point) => point.city));
    }, [points]);

    useEffect(() => {
        dispatch(fetchInventoryForms());
    }, [dispatch, paging]);

    useEffect(() => {
        onSearch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters]);

    const pointOptions = points.map(point => ({
        value: point.id,
        label: `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`,
    })).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
    });

    const setPageLimit = (e) => {
        e.preventDefault();
        const updatedPaging = { start: 0, limit: e.target.value};
        setCurrentPage(0);
        dispatch(setPagingInventory(updatedPaging));
    }
    
    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
        let nextStart =  data.selected * paging.limit;
        const updatedPaging = {...paging, start: nextStart};
        dispatch(setPagingInventory(updatedPaging));
    };

    const chekMarginPagesDisplayed = () => {
        const userDisplayWidth = window.innerWidth;

        if(userDisplayWidth < 400) return 1;
        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        if(userDisplayWidth < 1250) return 5;
        return 8;
    }

    const chekPageRangeDisplayed = () => {
        const userDisplayWidth = window.innerWidth;

        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        return 5;
    }

    const renderPagination = () => {
        const pages = Math.ceil(+count / +paging.limit);

        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={chekMarginPagesDisplayed()}
                    pageRangeDisplayed={chekPageRangeDisplayed()}
                    forcePage={currentPage}
                    onPageChange={handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />
                    <div className="kt-datatable__pager-info">
                        <div className="kt-datatable__pager-size">
                            <select onChange={setPageLimit} value={paging.limit} className="form-control">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            
                        </div>
                        {
                            paging.start + paging.limit >= count ? (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+count} из {count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+paging.start + +paging.limit} из {count}</span>
                            )
                        }
                       
                    </div>
            </div>
    
        );
    }

    const onSearch = () => {
        dispatch(setPagingInventory({ ...paging, start: 0 }));
        setCurrentPage(0);
        dispatch(fetchInventoryForms());
    }

    const onChangePoint = (e) => {
        const updated = { ...filters, point: e };
        dispatch(setInventoryFilters(updated));
    }

    const handleRecalculation = async () => {
        const ids = items.map((item) => item.id).filter((item) => item);
        if (!ids || ids.length === 0) return swal({
            title: "Инвентаризации не найдены",
            icon: "warning",
            dangerMode: true,
            button: "Ок"
        });

        if (ids.length > 10) return swal({
            title: "Лимит превышен",
            text: "Максимальное кол-во инвентаризация для пересчета за раз = 10",
            icon: "warning",
            dangerMode: true,
            button: "Ок"
        });

        try {
            const result = await dispatch(recalculationInventories(ids.sort((a, b) => a - b)));
            if (result && !result.error) {
                return swal({
                    title: "Успешно!",
                    text: "Процесс пересчета успешно запущен, ожидайте.",
                    icon: "success",
                    button: 'Ок'
                }).then(() => onRefresh());
            }
        } catch (error) {
            console.log(error)
            return swal({
                title: "Ошибка пересчета",
                text: `${(error.data && error.data.statusCode) ? `Код: ${error.data.statusCode}.` : ''}${(error.data && error.data.message) ? error.data.message : 'Неизвестная ошибка'}`,
                icon: "error",
                dangerMode: true,
                button: "Ок"
            }).then(() => onRefresh());
        }
    }

    return (
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid" style={{ padding: 0 }}>
            <div className='kt-form kt-form--label-right kt-margin-b-10'>
                {!isMobile ? 
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                        <div className="kt-subheader__group" id="kt_subheader_search">
                            <div style={{ width: 300, marginLeft: 15 }}>
                                <Select
                                    value={filters.point}
                                    onChange={onChangePoint}
                                    options={pointOptions}
                                    placeholder="Все филиалы"
                                    isClearable
                                    isLoading={pointsLoading}
                                />
                            </div>
                        </div>
                        {/* {user.role.id === roleId.admin && <button onClick={() => handleRecalculation()} className='btn btn-md btn-light'> Перерасчет </button>} */}
                    </div>
                    : UImobile.openFilters &&
                    <div key={window.innerWidth}>
                        <div className="mb-3 mobile-filter-item">
                            <label className="d-block">Филиал</label>
                            <Select
                                value={filters.point}
                                onChange={onChangePoint}
                                options={pointOptions}
                                placeholder="Все филиалы"
                                isClearable
                                isLoading={pointsLoading}
                            />
                        </div>
                    </div>
                }
                </div>
            <div className='kt-portlet'>
                <div className="kt-portlet__body kt-portlet__body--fit">
                    <div
                    style={{ position: 'relative' }}
                    className={cn(
                        'kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded',
                        { 'kt-datatable--error': !loading && isEmpty(items) }
                    )}
                    >
                        {loading && (
                            <div style={styles.tableLoading}>
                                <Loader text="Загружаем бланки..." />
                            </div>
                        )}
                        <table className="kt-datatable__table" style={window.innerWidth > 730 ? { minHeight: '700px' } : {}}>
                            {window.innerWidth > 730 && <TableHeader UImobile={UImobile}/>}
                            <tbody className="kt-datatable__body">
                            {
                            loading ? null : isEmpty(items) ? (
                                    <tr>
                                        <td colSpan={4}>
                                            <span className="kt-datatable--error">
                                                Бланков нет
                                            </span>
                                        </td>
                                    </tr>
                                )
                                : (
                                    items.map((item) =>
                                        <ItemRow
                                            key={item.id}
                                            item={item}
                                            cities={cities}
                                        />
                                    )
                                )
                            }
                            </tbody>
                        </table>
                        {items.length > 0 && renderPagination()}
                    </div>
                </div>
            </div>
            <ReactTooltip effect="solid" type="dark" place="top"/>
        </div>
    );
};

export default withRouter(InventoryList);
